import { forwardRef } from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@ui/lib/utils'

const textVariants = cva('text-gray-700', {
  variants: {
    size: {
      lg: 'text-lg',
      md: 'text-base',
      sm: 'text-sm',
      xs: 'text-xs',
    },
    weight: {
      normal: 'font-normal',
      medium: 'font-medium',
      semibold: 'font-semibold',
      bold: 'font-bold',
    },
  },
  defaultVariants: {
    size: 'md',
    weight: 'normal',
  },
})

export interface TextProps
  extends React.HTMLAttributes<HTMLElement>,
    VariantProps<typeof textVariants> {
  as?: 'p' | 'span' | 'div' | 'label'
}

export const Text = forwardRef<HTMLElement, TextProps>(
  ({ as: Component = 'p', size, weight, className, children, ...props }, ref) => {
    return (
      <Component
        ref={ref as any}
        className={cn(textVariants({ size, weight, className }))}
        {...props}
      >
        {children}
      </Component>
    )
  }
)

Text.displayName = 'Text'
